import uaParserJs from 'ua-parser-js';

export default {};

const result = uaParserJs(navigator.userAgent);

export function getDevice() {
    return result.device;
}

export function getDeviceOs() {
    // unknown mean neither iOS nor Android
    let deviceOs = 'Unknown';
    if (isIOS()) {
        deviceOs = 'iOS';
    } else if (isAndroid()) {
        deviceOs = 'Android';
    }
    return deviceOs;
}

export function isIOS() {
    return result.os.name === 'iOS';
}

export function isAndroid() {
    return result.os.name === 'Android';
}

export function isMobile() {
    return ['mobile', 'tablet'].includes(result.device.type ?? '');
}

export function isSafari() {
    return result.browser.name?.includes('Safari') ?? false;
}

export function isChrome() {
    return result.browser.name?.includes('Chrome') ?? false;
}

export function isFireFox() {
    return result.browser.name?.includes('Firefox') ?? false;
}

export function isOpera() {
    return result.browser.name?.includes('Opera') ?? false;
}

export function isUc() {
    return result.browser.name === 'UCBrowser';
}
